/******************
* --> Only on the 'git/ebook/en/command-line' pages! <--
*
* First-time visitors on the CLI version of the book should be asked
* if they wouldn't prefer to read the book in its Desktop GUI variant.
*
*******************/

if(typeof FN == 'undefined') FN = {};

FN.eBookDesktopOrCLI = {
  insertAtTopOfCSS: '.toc-content--top',
  containerCssId: 'desktop-gui-ebook-notice',
  relevantPagePathRule: 'git/ebook/en/command-line/.*',
  
  init: function(){
    if(!FN.eBookDesktopOrCLI._isRelevantPage()) return;
    if(!FN.ebookDesktopPageExists) return;
    if(FN.eBookDesktopOrCLI._hasBeenClosedBefore()) return;

    FN.eBookDesktopOrCLI._showNotice();
    $('#' + FN.eBookDesktopOrCLI.containerCssId + ' .box__close').on('click', function(){
      FN.eBookDesktopOrCLI.close();
    });
  },
  
  /*
  * Check if this page is relevant at all (--> git/ebook/en/command-line)
  */
  _isRelevantPage: function(){
    var re = new RegExp(FN.eBookDesktopOrCLI.relevantPagePathRule);
    var match = re.exec(window.location.pathname);
    return (match) ? true : false;
  },
  
  /*
  * Display the notice message
  */
  _showNotice: function(){
    var newPagePath = window.location.pathname.replace('en/command-line/', 'en/desktop-gui/');
    
    var noticeHtml = '<div class="box rule sans" id="'+ FN.eBookDesktopOrCLI.containerCssId +'">';
    noticeHtml    += '<div class="box__close">Hide</div>';
    noticeHtml    += '<h5>Learn the way you like</h5>';
    noticeHtml    += '<h4>Desktop GUI or Command Line?</h4>';
    noticeHtml    += '<p>To make learning Git as easy as possible for you, we provide this book in two different versions:</p>';
    noticeHtml    += '<ul>';
    noticeHtml    += '<li>This version teaches Git on the <b>Command Line</b>.</li>';
    noticeHtml    += '<li><a class="link--switch-to-desktop analytics--click" href="'+ newPagePath +'">Switch to the <b>Desktop GUI</b> version</a> if you prefer a simpler, more visual approach in a graphical user interface.</li>';
    noticeHtml    += '</ul>';
    noticeHtml    += '</div>';

    $(FN.eBookDesktopOrCLI.insertAtTopOfCSS).after(noticeHtml);
  },
  
  close: function(){
    $('#' + FN.eBookDesktopOrCLI.containerCssId).remove();
    FN.eBookDesktopOrCLI._setPreventReopenCookie();
  },
  
  _hasBeenClosedBefore: function(){
    var re = new RegExp(FN.eBookDesktopOrCLI.containerCssId + "=([^;]+)");
    var value = re.exec(document.cookie);
    return (value !== null) ? true : false;
  },

  /**
    Save a cookie if the user has closed the notice (so he doesn't see it again on his next visit)
  */
  _setPreventReopenCookie: function(){
    document.cookie = FN.eBookDesktopOrCLI.containerCssId +'=closed; path=/; expires=Tue, 07 Nov 2084 12:00:00 GMT';
  }
};




$( window ).on('load', function(){
  FN.eBookDesktopOrCLI.init();
});
